import './i18n';
import { HashRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { AuthProvider } from './contexts/AuthContext';
import { SnackbarProvider } from 'notistack';
import { Box } from '@mui/material';
import Navbar from './components/Navbar';
import AppRoutes from './routes';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false
    }
  }
});

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <QueryClientProvider client={queryClient}>
        <SnackbarProvider 
          maxSnack={3} 
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          autoHideDuration={3000}
        >
          <AuthProvider>
            <HashRouter>
              <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
                <Navbar />
                <Box sx={{ pt: 8 }}>
                  <AppRoutes />
                </Box>
              </Box>
            </HashRouter>
          </AuthProvider>
        </SnackbarProvider>
      </QueryClientProvider>
    </I18nextProvider>
  );
}

export default App; 